// Convert trusted HTML (author bios) to plain text. Insert spaces for
// <br>/closing block tags so words don't merge across paragraph breaks,
// then use DOMParser (not regex) so HTML entities decode safely.
export const stripHtml = (html: string): string => {
  const withBreaks = html.replace(/<br\s*\/?>|<\/(p|div|li|h[1-6])>/gi, " ");
  const parsed = new DOMParser().parseFromString(withBreaks, "text/html");
  return (parsed.body.textContent ?? "").replace(/\s+/g, " ").trim();
};
